import { Controller } from "@hotwired/stimulus";
import { initCatalogItemsDatatable } from "../../datatables/catalog_items_datatable";
import { isDatatableUninitialized } from "../../datatables/datatable_functions";

export default class extends Controller {
  initialize() {
    if (isDatatableUninitialized(this.element)) {
      initCatalogItemsDatatable(this.element);
    }
  }
}
